import { FuseLoadable } from "@fuse";

export const RPReconcilliationWorkflowReadOnlyUsersConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: "/app/rPRec/ROUsers",
      component: FuseLoadable({
        loader: () => import("./Mainworkflow")
      })
    }
  ]
};
